import {Injectable} from '@angular/core';
import {BannerIcon} from '../enums/banner/banner-icon.enum';
import {AvailableBannerType} from '../enums/banner/available-banner-type.enum';

@Injectable({
  providedIn: 'root'
})
export class BannerIconResolver {
  public resolve(bannerType: AvailableBannerType | undefined): BannerIcon {
    switch (bannerType) {
      case 'success':
        return BannerIcon.SUCCESS;
      case "error":
        return BannerIcon.ERROR;
      case "info":
        return BannerIcon.INFO;
      case "warn":
        return BannerIcon.WARN;
      default:
        return BannerIcon.UNDEFINED;
    }
  }
}
